import React from "react";

import { APP_ROUTES } from "navigation/route-registry";
import AthletesPage from "pages/app/athletes/athletes.page";
import AthleteProfilePage from "pages/app/athletes/athlete-profile.page";
import CountriesPage from "pages/app/countries/countries.page";
import DashboardPage from "pages/app/dashboard";
import MerchandiseDetailPage from "pages/app/merchandise/merchandise-detail.page";
import MerchandisePage from "pages/app/merchandise/merchandise.page";
import NewsDetailPage from "pages/app/news/news-detail.page";
import NewsPage from "pages/app/news/news.page";
import SportsPage from "pages/app/sports/sports.page";
import SportProfilePage from "pages/app/sports/sport-profile.page";
import TeamsPage from "pages/app/teams/teams";
import TeamProfilePage from "pages/app/teams/team-profile.page";
import ProfileEditPage from "pages/app/users/edit-profile.page";
import ProfilePage from "pages/app/users/profile.page";
import UsersPage from "pages/app/users/users.page";
import ViewUserPage from "pages/app/users/view-user.page";
import WorkspacePage from "pages/app/workspace";
import SchedulePage from "pages/app/workspace/schedule.page";
import SchoolHubPage from "pages/app/workspace/school-hub.page";
import SchoolMatchHubPage from "pages/app/workspace/school-match-hub.page";
import SchoolMatchScoresheetPage from "pages/app/workspace/school-match-scoresheet.page";
import SchoolPlayerProfilePage from "pages/app/workspace/school-player-profile.page";
import SchoolRosterProfilePage from "pages/app/workspace/school-roster-profile.page";
import SchoolTeamProfilePage from "pages/app/workspace/school-team-profile.page";

export const APP_ROUTE_PAGES: Record<string, React.ComponentType> = {
  dashboard: DashboardPage,
  sports: SportsPage,
  "sport-details": SportProfilePage,
  teams: TeamsPage,
  "team-details": TeamProfilePage,
  athletes: AthletesPage,
  "athlete-profile": AthleteProfilePage,
  merchandise: MerchandisePage,
  "merchandise-details": MerchandiseDetailPage,
  news: NewsPage,
  "news-details": NewsDetailPage,
  users: UsersPage,
  "user-profile": ViewUserPage,
  countries: CountriesPage,
  "administrative-regions": WorkspacePage,
  "sport-age-groups": WorkspacePage,
  profile: ProfilePage,
  "profile-edit": ProfileEditPage,
  school: SchoolHubPage,
  "school-staff-profile": ViewUserPage,
  "school-team-profile": SchoolTeamProfilePage,
  "school-player-profile": SchoolPlayerProfilePage,
  "school-roster-profile": SchoolRosterProfilePage,
  "school-scoresheet": SchoolMatchScoresheetPage,
  "school-match": SchoolMatchHubPage,
  "school-teams": WorkspacePage,
  "school-players": WorkspacePage,
  schedule: SchedulePage,
  "player-performance-records": WorkspacePage,
  "workspace-events": WorkspacePage,
  "workspace-player-classes": WorkspacePage,
  "workspace-requests": WorkspacePage,
  "workspace-player-profile": WorkspacePage,
  "workspace-player-stats": WorkspacePage,
  "workspace-orders": WorkspacePage,
  "workspace-payments": WorkspacePage,
  "workspace-wallet": WorkspacePage,
  "workspace-notifications": WorkspacePage,
  "workspace-followed-athletes": WorkspacePage,
  "workspace-section": WorkspacePage,
};

const missingPageRoutes = APP_ROUTES.filter(
  (route) => route.kind === "page" && !APP_ROUTE_PAGES[route.id],
);

if (missingPageRoutes.length) {
  throw new Error(
    `Missing page components for routes: ${missingPageRoutes.map((route) => route.id).join(", ")}`,
  );
}
